// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 768px){.ProductGalleryThumbnailImage{display:block;height:0;width:100%;padding-bottom:70%}}\n", ""]);
// Exports
module.exports = exports;
